/* Taken from this gist : https://gist.github.com/jackfuchs/556448 */
/**
 * [cssProperty description]
 * @param  string p - css property name
 * @param  bool rp - optional, if set to true, the css property name will be returned, instead of a boolean support indicator
 * @return {[type]}    [description]
 */
export function cssProperty (p, rp) {
  const b = document.body || document.documentElement
  const s = b.style

  // No css support detected
  if (typeof s === 'undefined') return false

  // Tests for standard prop
  if (typeof s[p] === 'string') return rp ? p : true

  // Tests for vendor specific prop
  const v = ['Moz', 'Webkit', 'Khtml', 'O', 'ms', 'Icab']
  p = p.charAt(0).toUpperCase() + p.substr(1)
  const max = v.length

  for (let i = 0; i < max; i++) { if (typeof s[v[i] + p] === 'string') return rp ? (v[i] + p) : true }

  return false
}
